
export const COLOR_BLUE = '#0088FE';
export const COLOR_GREEN ='#00C49F';
export const COLOR_YELLOW = '#FFBB28';
export const COLOR_RED = '#FF8042';